import { CopyOutlined, CopyTwoTone } from "@ant-design/icons";
import { Table, Typography } from "antd";
import { IntegrationStepSummary } from "components/CC/RunHistory/StepDetails/utils/types";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

import type { ColumnsType } from "antd/es/table";

const { Text } = Typography;

interface LeadDataRow {
    key: string;
    parameter: string;
    value: string;
}

export interface StepDetailIntegrationProps {
    extractedData: IntegrationStepSummary;
}

export const StepDetailIntegration: FC<StepDetailIntegrationProps> = ({ extractedData }) => {
    const { t } = usePaldockTranslation("drawers.step-detail.integration");
    const { t: tCommon } = usePaldockTranslation("common");

    const leadDataRows: LeadDataRow[] = extractedData.leadData.map(({ key, value }) => ({
        key,
        parameter: key,
        value,
    }));

    const leadDataColumns: ColumnsType<LeadDataRow> = [
        { dataIndex: "parameter", key: "parameter", width: "40%" },
        {
            dataIndex: "value",
            key: "value",
            ellipsis: true,
            render: (value: string) => (
                <Text
                    ellipsis={{ tooltip: value }}
                    copyable={{
                        text: value,
                        icon: [<CopyOutlined key="copy" />, <CopyTwoTone key="copied" />],
                        tooltips: [tCommon("copy_tooltips.click_to_copy"), tCommon("copy_tooltips.copied")],
                    }}
                    className="w-full flex justify-between items-center"
                >
                    {value}
                </Text>
            ),
        },
    ];

    return (
        <DrawerCollapsible title={t("data")}>
            <Table
                columns={leadDataColumns}
                dataSource={leadDataRows}
                pagination={false}
                size="small"
                bordered={false}
                showHeader={false}
            />
        </DrawerCollapsible>
    );
};
